// Centrally managed compliance wording for Precision Wealth.
// Approved by the business owner. Advisers operate as representatives of Liberty Group Limited (FSP 2409).
// Precision Wealth is a division of the Hereford Group.

export const LIBERTY_FSP = 'FSP 2409';

// Full licensing line (footers, disclosures, key surfaces)
export const COMPLIANCE_FULL =
  'Precision Wealth is a division of the Hereford Group. Our advisers are representatives of Liberty Group Limited, an Authorised Financial Services Provider (FSP 2409).';

// Compact one-liner for tight spaces (hero strip, chips)
export const COMPLIANCE_SHORT =
  'A division of the Hereford Group · Advisers are representatives of Liberty Group Limited (FSP 2409)';

// General FAIS education disclaimer
export const FAIS_EDUCATION_NOTE =
  'This platform is for general financial education only and does not constitute financial advice under the FAIS Act. Personal financial advice is provided solely by a qualified adviser within a formal advisory engagement.';
